/* Product detail page interactivity — INXL World.
 * Variant selection (chips/swatches) → resolve variant → update selected-value
 * labels, price, and the add-to-cart CTA state. Add uses window.__cart (opens
 * the cart drawer). Also drives the gallery thumbnails, the description/shipping
 * accordion, the size-guide drawer, and the desktop sticky order bar.
 * Early-returns off the PDP. Mirrors assets/product-card.js's resolution logic.
 */
(function () {
  var root = document.querySelector('[data-pdp]');
  if (!root) return;
  var dataEl = root.querySelector('[data-pdp-json]');
  var addBtn = root.querySelector('[data-pdp-add]');
  if (!dataEl || !addBtn) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var options = data.options || [];
  var optionValues = data.optionValues || [];
  var variants = data.variants || [];
  var cartVariantIds = {}; // variant id (string) -> { key, qty }, filled from /cart.js
  var stepper = root.querySelector('[data-pdp-stepper]');
  var qtyNum = root.querySelector('[data-pdp-qty-num]');
  function updateCartState(cart) {
    cartVariantIds = {};
    ((cart && cart.items) || []).forEach(function (it) { cartVariantIds[String(it.variant_id)] = { key: it.key, qty: it.quantity }; });
  }
  var isSimple = options.length <= 1 && (options.length === 0 || options[0] === 'Title');

  var selected = {};
  optionValues.forEach(function (vals, i) { if (vals && vals.length === 1) selected[i] = vals[0]; });
  // Deep-link: preselect the axes of ?variant=<id> (Shopify's standard variant URL).
  try {
    var vparam = new URLSearchParams(window.location.search).get('variant');
    if (vparam) {
      var pv = variants.filter(function (x) { return String(x.id) === String(vparam); })[0];
      if (pv) options.forEach(function (name, i) { if (name !== 'Title') selected[i] = pv.opts[i]; });
    }
  } catch (e) {}

  var priceEl = root.querySelector('.pdp__price');
  var compareEl = root.querySelector('.pdp__compare');
  var saleEl = root.querySelector('.pdp__sale');
  var stickyPriceEl = root.querySelector('[data-pdp-sticky-price]');
  var stickyBar = root.querySelector('[data-pdp-sticky]');
  var stickyAdd = root.querySelector('[data-pdp-sticky-add]');

  function missingIndex() {
    for (var i = 0; i < options.length; i++) {
      if (options[i] === 'Title') continue;
      if (selected[i] == null) return i;
    }
    return -1;
  }
  function resolveVariant() {
    if (isSimple) return variants[0] || null;
    if (missingIndex() !== -1) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < v.opts.length; j++) {
        if (selected[j] != null && v.opts[j] !== selected[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  // A given option value is "available" when some variant carrying it — and
  // matching the currently-selected OTHER axes — is in stock. Drives the
  // strike-through on sold-out sizes/values so they read as unpickable.
  function valueAvailable(idx, val) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.opts[idx] !== val) continue;
      var ok = true;
      for (var j = 0; j < options.length; j++) {
        if (j === idx || options[j] === 'Title') continue;
        if (selected[j] != null && v.opts[j] !== selected[j]) { ok = false; break; }
      }
      if (ok && v.available) return true;
    }
    return false;
  }
  // Recomputed on every render so it reflects the current cross-axis selection
  // (e.g. picking a colour re-evaluates which sizes are still in stock).
  function syncAvailability() {
    if (isSimple) return;
    root.querySelectorAll('[data-pdp-opt] [data-opt-value]').forEach(function (chip) {
      var idx = parseInt(chip.getAttribute('data-opt-index'), 10);
      var avail = valueAvailable(idx, chip.getAttribute('data-opt-value'));
      chip.classList.toggle('is-unavailable', !avail);
      chip.setAttribute('aria-disabled', avail ? 'false' : 'true');
    });
  }

  function updateOptLabels() {
    root.querySelectorAll('[data-pdp-opt]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-pdp-opt'), 10);
      var el = group.querySelector('[data-pdp-opt-value]');
      if (el) el.textContent = selected[idx] != null ? (': ' + selected[idx]) : '';
    });
  }

  // Reflect the current `selected` state on the chips/swatches (auto-selected
  // single-value axes + any ?variant deep-link preselection).
  function syncChips() {
    root.querySelectorAll('[data-pdp-opt] [data-opt-value]').forEach(function (chip) {
      var idx = parseInt(chip.getAttribute('data-opt-index'), 10);
      chip.classList.toggle('is-selected', selected[idx] === chip.getAttribute('data-opt-value'));
    });
  }

  function updatePrice(v) {
    if (!v || !v.price) return;
    if (priceEl) priceEl.textContent = v.price;
    if (stickyPriceEl) stickyPriceEl.textContent = v.price;
    if (compareEl) compareEl.style.display = v.compare ? '' : 'none';
    if (compareEl && v.compare) compareEl.textContent = v.compare;
    if (saleEl) saleEl.style.display = v.compare ? '' : 'none';
  }

  // Mirror the primary CTA's label + disabled state onto the sticky bar's button.
  function syncSticky() {
    if (!stickyAdd) return;
    stickyAdd.textContent = addBtn.textContent;
    stickyAdd.disabled = addBtn.disabled;
  }

  // The Notify Me app block (Notim) has no awareness of the currently selected
  // variant and would otherwise always render — show it ourselves only when the
  // resolved variant is genuinely sold out, swapped in for the buy box (not
  // stacked underneath it).
  var notifyWrap = root.querySelector('[data-pdp-notify]');
  var buyWrap = root.querySelector('[data-pdp-buy]');
  function syncNotify(show) {
    if (notifyWrap) notifyWrap.hidden = !show;
    if (buyWrap) buyWrap.hidden = show;
  }

  function render() {
    syncAvailability();
    var miss = isSimple ? -1 : missingIndex();
    if (miss !== -1) { addBtn.disabled = true; addBtn.textContent = 'Select ' + String(options[miss]).toLowerCase(); syncSticky(); syncNotify(false); return; }
    var v = resolveVariant();
    if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; syncSticky(); syncNotify(false); return; }
    updatePrice(v);
    // In cart — this session's add OR the variant is already in the live cart.
    var line = cartVariantIds[String(v.id)];
    if (root.dataset.added === '1' || line) {
      addBtn.disabled = false; addBtn.textContent = 'In cart ✓';
      if (stepper) { stepper.hidden = !line; if (line && qtyNum) qtyNum.textContent = line.qty; }
      syncSticky(); syncNotify(false); return;
    }
    if (stepper) stepper.hidden = true;
    if (!v.available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; syncSticky(); syncNotify(true); return; }
    addBtn.disabled = false;
    addBtn.textContent = addBtn.dataset.label || 'Add to cart';
    syncSticky();
    syncNotify(false);
  }

  root.querySelectorAll('[data-pdp-opt] [data-opt-value]').forEach(function (chip) {
    chip.addEventListener('click', function (e) {
      e.preventDefault();
      // Sold-out values (struck through) are still selectable — picking one
      // resolves to an unavailable variant, which flips the CTA to "Sold out"
      // and surfaces the Notify Me app block for that specific variant.
      var idx = parseInt(chip.getAttribute('data-opt-index'), 10);
      selected[idx] = chip.getAttribute('data-opt-value');
      var group = chip.closest('[data-pdp-opt]');
      if (group) group.querySelectorAll('[data-opt-index="' + idx + '"]').forEach(function (c) { c.classList.toggle('is-selected', c === chip); });
      root.dataset.added = '0';
      updateOptLabels();
      render();
    });
  });

  // PDP quantity stepper (shown when the variant is in the cart) — ± changes the line qty.
  function stepChange(delta) {
    var v = resolveVariant();
    if (!v) return;
    var line = cartVariantIds[String(v.id)];
    if (!line || !(window.__cart && window.__cart.changeLine)) return;
    var next = line.qty + delta;
    if (next < 0) next = 0;
    window.__cart.changeLine(line.key, next).then(function (cart) { updateCartState(cart); render(); }).catch(function () {});
  }
  var qDec = root.querySelector('[data-pdp-qty-dec]');
  var qInc = root.querySelector('[data-pdp-qty-inc]');
  if (qDec) qDec.addEventListener('click', function () { stepChange(-1); });
  if (qInc) qInc.addEventListener('click', function () { stepChange(1); });

  // Shared add flow — used by both the main CTA and the sticky bar's button.
  function doAdd() {
    var v = resolveVariant();
    if (!v || !v.available) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    syncSticky();
    // Pre-order line-item property → carries the dispatch date into the cart,
    // order, and Order-confirmation email. Sourced from the metafield-driven
    // data-* stamped on the CTA (sections/main-product.liquid).
    var props = null;
    if (addBtn.dataset.preorder === '1') {
      var ship = addBtn.dataset.preorderShip;
      props = { 'Pre-order': ship ? ('Ships from ' + ship) : 'Yes' };
      // Hidden, sortable ISO copy so the email can pick the latest date across items.
      var iso = addBtn.dataset.preorderShipIso;
      if (iso) props['_preorder_iso'] = iso;
    }
    var p = (window.__cart && window.__cart.addToCart)
      ? window.__cart.addToCart(v.id, 1, props)
      : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1, properties: props || undefined }) }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    p.then(function () {
      root.dataset.added = '1';
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { updateCartState(cart); render(); }).catch(function () { render(); });
    }).catch(function () { root.dataset.added = '0'; render(); });
  }

  addBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (addBtn.disabled) return;
    // Already added → tapping the CTA opens the drawer instead of re-adding.
    if (root.dataset.added === '1') { if (window.__cart && window.__cart.openDrawer) window.__cart.openDrawer(); return; }
    doAdd();
  });

  if (stickyAdd) {
    stickyAdd.addEventListener('click', function (e) {
      e.preventDefault();
      // Not ready to add (variant unpicked / unavailable) → bring the main
      // picker + CTA into view rather than firing.
      if (addBtn.disabled && root.dataset.added !== '1') { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (root.dataset.added === '1') { if (window.__cart && window.__cart.openDrawer) window.__cart.openDrawer(); return; }
      doAdd();
    });
  }

  // Gallery thumbnails → switch the active main slide.
  root.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var i = thumb.getAttribute('data-pdp-thumb');
      root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      root.querySelectorAll('[data-pdp-slide]').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-pdp-slide') === i); });
    });
  });

  // Accordion — single open at a time; clicking the open row closes it.
  root.querySelectorAll('[data-acc-head]').forEach(function (head) {
    head.addEventListener('click', function () {
      var row = head.closest('.pdp__acc-row');
      if (!row) return;
      var willOpen = !row.classList.contains('is-open');
      root.querySelectorAll('.pdp__acc-row').forEach(function (r) {
        r.classList.remove('is-open');
        var h = r.querySelector('[data-acc-head]');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) { row.classList.add('is-open'); head.setAttribute('aria-expanded', 'true'); }
    });
  });

  // Size-guide drawer — opened from the Size row, closed via ✕ / backdrop / Esc.
  var sgDrawer = root.querySelector('[data-size-guide-drawer]');
  function openSizeGuide() {
    if (!sgDrawer) return;
    sgDrawer.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeSizeGuide() {
    if (!sgDrawer) return;
    sgDrawer.hidden = true;
    document.body.style.overflow = '';
  }
  root.querySelectorAll('[data-size-guide]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openSizeGuide(); });
  });
  if (sgDrawer) {
    sgDrawer.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
      el.addEventListener('click', closeSizeGuide);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sgDrawer.hidden) closeSizeGuide(); });
  }

  // Sticky order bar — reveal once the primary CTA scrolls out of view.
  if (stickyBar && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
      stickyBar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
    }, { threshold: 0.01 });
    io.observe(addBtn);
  }

  // Recommendations carousel dots (mobile, 2 cards per view). Dots track PAGES,
  // not individual cards — otherwise the count doubles and a trailing dot points
  // past the last card. Highlights the current page on scroll; scrolls one page
  // on click. Hidden on desktop (CSS).
  (function () {
    var grid = root.querySelector('.pdp__reco-grid');
    var dotsWrap = root.querySelector('[data-pdp-reco-dots]');
    if (!grid || !dotsWrap) return;
    var cards = Array.prototype.slice.call(grid.children);
    var MPV = 2;
    var pages = Math.ceil(cards.length / MPV);
    if (pages < 2) return;
    for (var pi = 0; pi < pages; pi++) {
      (function (idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp__reco-dot' + (idx === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Page ' + (idx + 1));
        b.addEventListener('click', function () {
          var target = cards[idx * MPV];
          if (!target) return;
          var delta = target.getBoundingClientRect().left - grid.getBoundingClientRect().left;
          grid.scrollTo({ left: grid.scrollLeft + delta, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
      })(pi);
    }
    var dots = Array.prototype.slice.call(dotsWrap.children);
    var raf = null;
    grid.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var gl = grid.getBoundingClientRect().left, idx = 0, best = Infinity;
        cards.forEach(function (c, i) { var d = Math.abs(c.getBoundingClientRect().left - gl); if (d < best) { best = d; idx = i; } });
        var pageIdx = Math.floor(idx / MPV);
        if (grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2) pageIdx = pages - 1;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === pageIdx); });
      });
    });
  })();

  syncChips();
  updateOptLabels();
  render();

  // Reflect the live cart on load (returning shopper sees "In cart" for a variant
  // that's already in their cart, not just after an in-session add).
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartState(cart); render(); })
    .catch(function () {});
})();
